export enum User {
  AUTHENTICATED = "AUTHENTICATED",
  DO_LOGOUT = "DO_LOGOUT",
  SET_USERPROFILE = "SET_USERPROFILE",
}
